<template>
  <div>
    <div v-if="selectGridCardMenuHistory.length > 0" class="flex items-center p-3" style="font-size: 1.5rem">
      <div class="flex items-center cursor-pointer" @click="onBackCardMenu"><feather-icon icon="ChevronLeftIcon" style="width: 2rem; height: 2rem" /> 뒤로가기</div>
    </div>
    <div class="m-dashboard-menu px-4 mb-4" :class="selectGridCardMenuHistory.length > 0 && 'subMenu'">
      <div v-for="(menu, menuIdx) in gridCardMenus" v-if="enabledCard(menu)" class="item flex items-center justify-center" style="background: #fff" :key="menuIdx">
        <component :is="menu.url ? 'router-link' : 'div'" :to="menu.url" :class="menu.url ? '' : 'cursor-pointer'" @click="onClickCardMenu(menu)">
          <div>
            <div class="mt-4 mb-2 flex justify-center">
              <feather-icon :icon="menu.icon" />
            </div>
            <div class="text-center">
              <span style="font-size: 18px; font-weight: 500; color: #353535">{{ menu.name }}</span>
            </div>
          </div>
        </component>
      </div>
    </div>
    <vs-card class="m-alarm-list mx-4">
      <div>
        <h5>
          <i class="dot"></i>알림현황 <span>(최근 {{ alertList.length }}건)</span>
        </h5>
      </div>
      <div v-for="alert in alertList" class="mt-3 p-3 board" @click="onClickAlert(alert)">
        <p style="font-size: 13px; color: #000; font-weight: 400">{{ alert.message }}</p>
        <p class="mt-2" style="font-size: 12px; color: #696d71; font-weight: 400">{{ alert.created_at }}</p>
      </div>
      <div v-if="alertList.length === 0" class="mt-3 p-6 board">
        <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
      </div>
    </vs-card>
  </div>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";
import HomeNotificationCard from "@/components/HomeNotificationCard";
import CommunityHealthinfoCard from "@/components/CommunityHealthinfoCard";
import CommunityWorkNewsCard from "@/components/CommunityWorkNewsCard";
import CommunityBusinessNewsCard from "@/components/CommunityBusinessNewsCard";
import HealthSafetyBudgetExecutionRateChart from "@/views/graph/HeathSafetyBudgetExecutionRateChart";

export default {
  components: {
    HealthSafetyBudgetExecutionRateChart,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard,
  },
  data() {
    return {
      rootPath: "",
      successLoadGraph: false,
      alertList: [],
      selectGridCardMenuHistory: [],
    };
  },
  async created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then((value) => {
      this.successLoadGraph = true;
    });
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    gridCardMenus() {
      if (this.selectGridCardMenuHistory.length > 0) {
        return this.selectGridCardMenuHistory[this.selectGridCardMenuHistory.length - 1];
      } else {
        return this.mobileCardMenus;
      }
    },
    mobileCardMenus() {
      if (Number(`${this.projectId}`) === 2) {
        return [
          {
            url: `tab/307`,
            name: "안전 사고 발생 보고서",
            icon: "CheckSquareIcon",
            boardId: "307",
          },
          {
            url: `tab/244`,
            name: "중대재해 발생 보고",
            icon: "CheckSquareIcon",
            boardId: "244",
          },
          {
            url: "tab/434",
            name: "안전·보건 교육",
            icon: "BookOpenIcon",
            boardId: "434",
          },
          {
            name: "안전·보건 점검표",
            icon: "CheckSquareIcon",
            boardId: "",
            children: [
              {
                url: "tab/137/write",
                name: "안전·보건 점검 계획",
                icon: "",
                boardId: "137",
              },
              {
                url: "tab/291/write",
                name: "안전 순회점검표(현장)",
                icon: "",
                boardId: "291",
              },
              {
                url: "tab/290/write",
                name: "안전 순회점검표(현장)",
                icon: "",
                boardId: "290",
              },
              {
                url: "tab/519/write",
                name: "안전, 보건 순회점검표",
                icon: "",
                boardId: "519",
              },
            ],
          },
          {
            url: "tab/289/write",
            name: "자체점검표(사무실)",
            icon: "UserCheckIcon",
            boardId: "289",
          },
          {
            url: "tab/158/write",
            name: "위험요인 파악",
            icon: "UserCheckIcon",
            boardId: "158",
          },
          {
            url: "tab/450/write",
            name: "정기 위험성평가",
            icon: "UserCheckIcon",
            boardId: "450",
          },
          {
            name: "기타 점검표",
            icon: "CheckSquareIcon",
            boardId: "",
            children: [
              {
                url: "tab/163/write",
                name: "일일안전보건점검일지",
                icon: "",
                boardId: "163",
              },
              {
                url: "tab/100/write",
                name: "작업장 합동 순회점검표",
                icon: "",
                boardId: "100",
              },
              {
                url: "tab/289/write",
                name: "안전보건 순회점검표(사무실)",
                icon: "",
                boardId: "289",
              },
              {
                url: "tab/292/write",
                name: "근골격계 증상조사표(근로자)",
                icon: "",
                boardId: "292",
              },
              {
                url: "tab/293/write",
                name: "근골격계부담작업 체크리스트",
                icon: "",
                boardId: "293",
              },
              {
                url: "tab/296/write",
                name: "동청사 안전점검표",
                icon: "",
                boardId: "296",
              },
              {
                url: "tab/219/write",
                name: "(건설현장) 건설기계·장비별",
                icon: "",
                boardId: "219",
              },
              {
                url: "tab/221/write",
                name: "(건설현장) 공정별",
                icon: "",
                boardId: "221",
              },
              {
                url: "tab/216",
                name: "(건설현장) 사고유형별",
                icon: "",
                boardId: "216",
              },
              {
                url: "tab/220/write",
                name: "(건설현장) 위험작업별",
                icon: "",
                boardId: "220",
              },
              {
                url: "tab/112/write",
                name: "(건설현장) 일반관리",
                icon: "",
                boardId: "112",
              },
              {
                url: "tab/180/write",
                name: "가지치기",
                icon: "",
                boardId: "180",
              },
              {
                url: "tab/210/write",
                name: "건설기계·장비별",
                icon: "",
                boardId: "210",
              },
              {
                url: "tab/196/write",
                name: "급식 점검표",
                icon: "",
                boardId: "196",
              },
              {
                url: "tab/213/write",
                name: "곤돌라 작업",
                icon: "",
                boardId: "213",
              },
              {
                url: "tab/200/write",
                name: "근골격계 질환",
                icon: "",
                boardId: "200",
              },
              {
                url: "tab/188/write",
                name: "근로자 건강관리(공통)",
                icon: "",
                boardId: "188",
              },
              {
                url: "tab/203/write",
                name: "기계식 주차설비 작업",
                icon: "",
                boardId: "203",
              },
              {
                url: "tab/212/write",
                name: "기계톱 작업",
                icon: "",
                boardId: "212",
              },
              {
                url: "tab/176/write",
                name: "기둥, 벽, 보, 천장",
                icon: "",
                boardId: "176",
              },
              {
                url: "tab/166/write",
                name: "냉온수기 및 보일러 설비",
                icon: "",
                boardId: "166",
              },
              {
                url: "tab/226/write",
                name: "다목적 체육관 안전점검표",
                icon: "",
                boardId: "226",
              },
              {
                url: "tab/224/write",
                name: "다목적실 안전점검표",
                icon: "",
                boardId: "224",
              },
              {
                url: "tab/110/write",
                name: "도로 보수",
                icon: "",
                boardId: "110",
              },
              {
                url: "tab/189/write",
                name: "밀폐공간 작업",
                icon: "",
                boardId: "189",
              },
              {
                url: "tab/230/write",
                name: "보도 육교 승강기 안전점검표",
                icon: "",
                boardId: "230",
              },
              {
                url: "tab/229/write",
                name: "보도 육교 안전점검표",
                icon: "",
                boardId: "229",
              },
              {
                url: "tab/205/write",
                name: "복도 및 화장실청소",
                icon: "",
                boardId: "205",
              },
              {
                url: "tab/171/write",
                name: "부대 시설",
                icon: "",
                boardId: "171",
              },
              {
                url: "tab/172/write",
                name: "비상설비",
                icon: "",
                boardId: "172",
              },
              {
                url: "tab/199/write",
                name: "사다리 작업",
                icon: "",
                boardId: "199",
              },
              {
                url: "tab/182/write",
                name: "산불예방감시",
                icon: "",
                boardId: "182",
              },
              {
                url: "tab/184/write",
                name: "산불진화작업",
                icon: "",
                boardId: "184",
              },
              {
                url: "tab/227/write",
                name: "샤워실 안전점검표",
                icon: "",
                boardId: "227",
              },
              {
                url: "tab/174/write",
                name: "소방 및 신호기",
                icon: "",
                boardId: "174",
              },
              {
                url: "tab/173/write",
                name: "소방용수 탱크",
                icon: "",
                boardId: "173",
              },
              {
                url: "tab/113/write",
                name: "수영장 안전점검표",
                icon: "",
                boardId: "113",
              },
              {
                url: "tab/225/write",
                name: "스트레칭실 안전점검표",
                icon: "",
                boardId: "225",
              },
              {
                url: "tab/206/write",
                name: "승강기 작업",
                icon: "",
                boardId: "206",
              },
              {
                url: "tab/168/write",
                name: "시설물 관리(공통)",
                icon: "",
                boardId: "168",
              },
              {
                url: "tab/169/write",
                name: "시설물 내부",
                icon: "",
                boardId: "169",
              },
              {
                url: "tab/170/write",
                name: "시설물 외부",
                icon: "",
                boardId: "170",
              },
              {
                url: "tab/223/write",
                name: "실내체육관 안전점검표",
                icon: "",
                boardId: "223",
              },
              {
                url: "tab/179/write",
                name: "실외기 및 완강기",
                icon: "",
                boardId: "179",
              },
              {
                url: "tab/194/write",
                name: "쓰레기 수거 작업",
                icon: "",
                boardId: "194",
              },
              {
                url: "tab/201/write",
                name: "안전보건교육",
                icon: "",
                boardId: "201",
              },
              {
                url: "tab/233/write",
                name: "어린이집 안전점검표",
                icon: "",
                boardId: "233",
              },
              {
                url: "tab/211/write",
                name: "예초기 작업",
                icon: "",
                boardId: "211",
              },
              {
                url: "tab/193/write",
                name: "외벽 청소 작업",
                icon: "",
                boardId: "193",
              },
              {
                url: "tab/164/write",
                name: "요양보호사",
                icon: "",
                boardId: "164",
              },
              {
                url: "tab/208/write",
                name: "위험대비 매뉴얼 대응조치 점검",
                icon: "",
                boardId: "208",
              },
              {
                url: "tab/202/write",
                name: "위험작업별",
                icon: "",
                boardId: "202",
              },
              {
                url: "tab/190/write",
                name: "유해화학물질 작업",
                icon: "",
                boardId: "190",
              },
              {
                url: "tab/197/write",
                name: "응급조치",
                icon: "",
                boardId: "197",
              },
              {
                url: "tab/192/write",
                name: "작업장 바닥 작업",
                icon: "",
                boardId: "192",
              },
              {
                url: "tab/178/write",
                name: "전기 외함",
                icon: "",
                boardId: "178",
              },
              {
                url: "tab/177/write",
                name: "전기시설",
                icon: "",
                boardId: "177",
              },
              {
                url: "tab/207/write",
                name: "전기작업",
                icon: "",
                boardId: "207",
              },
              {
                url: "tab/231/write",
                name: "제방 안전점검표",
                icon: "",
                boardId: "231",
              },
              {
                url: "tab/165/write",
                name: "종사자 및 주차시설",
                icon: "",
                boardId: "165",
              },
              {
                url: "tab/175/write",
                name: "주차시설",
                icon: "",
                boardId: "175",
              },
              {
                url: "tab/191/write",
                name: "중량물 작업 시 안전점검",
                icon: "",
                boardId: "191",
              },
              {
                url: "tab/214/write",
                name: "지게차 안전점검표",
                icon: "",
                boardId: "214",
              },
              {
                url: "tab/181/write",
                name: "진드기 및 질병예방",
                icon: "",
                boardId: "181",
              },
              {
                url: "tab/204/write",
                name: "청소(미화) 점검표",
                icon: "",
                boardId: "204",
              },
              {
                url: "tab/187/write",
                name: "청소차량",
                icon: "",
                boardId: "187",
              },
              {
                url: "tab/186/write",
                name: "청소차량 및 환경미화원",
                icon: "",
                boardId: "186",
              },
              {
                url: "tab/185/write",
                name: "청원경찰",
                icon: "",
                boardId: "185",
              },
              {
                url: "tab/228/write",
                name: "탈의실 안전점검표",
                icon: "",
                boardId: "228",
              },
              {
                url: "tab/183/write",
                name: "풀베기",
                icon: "",
                boardId: "183",
              },
              {
                url: "tab/167/write",
                name: "행사자 동선 및 관계자",
                icon: "",
                boardId: "167",
              },
              {
                url: "tab/222/write",
                name: "헬스장 안전점검표",
                icon: "",
                boardId: "222",
              },
              {
                url: "tab/195/write",
                name: "화기·용접 작업",
                icon: "",
                boardId: "195",
              },
              {
                url: "tab/438/write",
                name: "휴게시설 주요 체크리스트",
                icon: "",
                boardId: "438",
              },
            ],
          },
        ];
      } else if (Number(`${this.projectId}`) === 5) {
        return [
          {
            url: `dashboard`,
            name: "스마트 대시보드",
            icon: "PieChartIcon",
            boardId: "",
          },
          {
            url: "tab/613/write",
            name: "유해·위험요인 점검 체크리스트",
            icon: "CheckSquareIcon",
            boardId: "613",
          },
          {
            url: "tab/649/write",
            name: "(건축물)유해·위험요인 발생 및 조치현황",
            icon: "ToolIcon",
            boardId: "649",
          },
          {
            url: "tab/640/write",
            name: "중대시민재해 발생 보고서",
            icon: "FileTextIcon",
            boardId: "640",
          },
        ];
      }
      return [];
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    myLv() {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    boardIds() {
      return this.$store.state.menu.availableBoardIds;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    hasDashboardCharts() {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts;
      if (hasDashboardCharts) {
        const list = [];
        for (const chart of hasDashboardCharts) {
          if (chart.visible && Number(`${chart.project_id}`) === Number(`${this.projectId}`)) {
            const code = chart.dashboard_chart.code;
            list.push(code);
          }
        }
        return list;
      }

      return undefined;
    },
    rootCompanyList() {
      const list = [];
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== "undefined" && typeof company.com_type !== "undefined" && company.com_type === "head") {
          list.push(company);
        }
      }
      return list;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true;
          break;
        }
      }

      return isAdmin;
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = [];
      let hasRootHead = false;
      const headList = [];

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && typeof com.descendant.com_type !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    dataType() {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return "detail";
      }
      return "company";
    },
  },
  async mounted() {
    // await this.loadCompanyList()

    if (this.verticalNavMenuWidth !== "default") {
      await this.loadAlertList();
    }
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },

    async loadAlertList() {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      };
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_LIST", options);

      const readList = this.$store.state.approval.alertReadList;
      const unreadList = this.$store.state.approval.alertUnReadList;

      this.alertList = unreadList;
    },

    enabledCard(menu) {
      // 대시보드는 관리자만 접근 가능
      if (menu.onlyAdmin && this.isAdmin) {
        return true;
      }

      if (!menu.boardId) return true;

      // 권한을 갖고 있는 게시판 번호들 중에 해당 게시판이 있는지 확인
      return this.boardIds.includes(Number(`${menu.boardId}`));
    },

    onClickAlert(alert) {
      const data = JSON.parse(alert.data);
      if (data && data.project_id && data.board_id && data.post_id) {
        const projectId = data.project_id;
        const boardId = data.board_id;
        const postId = data.post_id;
        this.$router.push({ path: `/project/${projectId}/tab/${boardId}/write/${postId}` });
      }
    },
    onClickCardMenu(menu) {
      if (!menu.url) {
        if (menu.children) {
          this.selectGridCardMenuHistory.push(menu.children);
        }
      }
    },
    onBackCardMenu() {
      if (this.selectGridCardMenuHistory.length > 0) {
        this.selectGridCardMenuHistory.pop();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
  }
  @media (min-width: 960px) {
    .item {
      padding: 2.5rem 0.5rem;
    }
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
.m-alarm-list {
  width: auto;
  .board {
    border: 1px solid #cdcdcd;
  }
}
</style>
